import { BloomfallGame } from './bloomfall/BloomfallGame';
import { FeltGame } from './felt/FeltGame';
import { HexboundGame } from './hexbound/HexboundGame';
import { NestGame } from './nest/NestGame';
import { NightServiceGame } from './nightservice/NightServiceGame';
import { TidehaulGame } from './tidehaul/TidehaulGame';
import { VoidNeedleGame } from './voidneedle/VoidNeedleGame';
import type { GameMeta } from '../platform/types';

export const GAMES: GameMeta[] = [
  {
    id: 'bloomfall',
    title: 'Bloomfall',
    tagline: 'Last twelve minutes in a grove that wants you gone.',
    genre: 'Survivor',
    minutes: '12 min',
    accent: '#c9a6ff',
    glow: '#7c5cff88',
    art: '/art/bloomfall.jpg',
    controls: 'WASD move · Space dash · Esc pause',
    how: 'Auto-fire, pick blooms, outlast the Night Root.',
    component: BloomfallGame,
  },
  {
    id: 'tidehaul',
    title: 'Tidehaul',
    tagline: 'Eight jobs. One van. Do not spill the soup.',
    genre: '3D Driving',
    minutes: '12 min',
    accent: '#ffb020',
    glow: '#ffb02066',
    art: '/art/tidehaul.jpg',
    controls: 'WASD drive · stick on phone · hit the pink pad',
    how: 'Third-person deliveries through a toy suburb.',
    component: TidehaulGame,
  },
  {
    id: 'felt',
    title: 'The Felt',
    tagline: 'A private room. Five tables. One bankroll.',
    genre: 'Cards',
    minutes: 'open',
    accent: '#7cffb2',
    glow: '#1f6b4488',
    art: '/art/felt.jpg',
    controls: 'Click cards and bets · cash out anytime',
    how: 'Blackjack, Hold’em, Klondike, Pyramid, High-Low.',
    component: FeltGame,
  },
  {
    id: 'nest',
    title: 'Nest & Reset',
    tagline: 'Twelve rooms. Ghost outlines. A closing truck.',
    genre: 'Tidy',
    minutes: '15 min',
    accent: '#e8c39e',
    glow: '#c48a4a66',
    art: '/art/nest.jpg',
    controls: 'Drag · right-click / double-tap rotate',
    how: 'Snap furniture into the pale ghosts. Combos pay.',
    component: NestGame,
  },
  {
    id: 'nightservice',
    title: 'Night Service',
    tagline: 'Ten nights. One cook. The line never stops.',
    genre: 'Cooking',
    minutes: '14 min',
    accent: '#ff8a5b',
    glow: '#ff5d3a66',
    art: '/art/nightservice.jpg',
    controls: 'WASD move · Space / Use at a station',
    how: 'Chop, grill, plate, serve, mop, upgrade.',
    component: NightServiceGame,
  },
  {
    id: 'voidneedle',
    title: 'Void Needle',
    tagline: 'Three sectors. One needle. Do not blink.',
    genre: 'Shmup',
    minutes: '12 min',
    accent: '#3ee0c5',
    glow: '#3ee0c566',
    art: '/art/voidneedle.jpg',
    controls: 'WASD move · hold Shift focus · Space bomb',
    how: 'Chain shots, bomb the screen, break three bosses.',
    component: VoidNeedleGame,
  },
  {
    id: 'hexbound',
    title: 'Hexbound',
    tagline: 'Fifteen waves. Three maps. The path stays open.',
    genre: 'Strategy',
    minutes: '15 min',
    accent: '#7aa2ff',
    glow: '#3a62c888',
    art: '/art/hexbound.jpg',
    controls: '1–5 select · click hex · Space start wave',
    how: 'Build, merge ranks, never block the lane.',
    component: HexboundGame,
  },
];
